// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../../../ts/ServerApi/types/IWorkbookActions';
import { resumeExtractRefresh } from '../../../actions/spaces/ResumeExtractRefreshAction';
import { selectSpaceInfoItem } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { hasExtractRefreshPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ResumeExtractRefreshEntityAction: IEntityAction<IExtractTaskInfo, IWorkbookActions> = {
  name: EntityActionNames.TasksResumeExtractRefresh,
  translateName: Messages.resumeExtractRefresh_action,
  isVisible: () => FeatureFlags.resumePausedExtractRefresh,
  isClickable: isClickable,
  createReduxAction: resumeExtractRefresh
};

function isClickable(
  availableActions: IWorkbookActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions) && hasDisabledTasks(tasks);
}

function hasDisabledTasks(
  tasks: IExtractTaskInfo[]
): boolean {
  return tasks.some(task => task.state === 'Disabled');
}
